import React from 'react';
import { Button, Title } from '@gerdau/hefesto';
import { StepPropsRequestApprovalPanel } from '../types';
import {
  UserEvaluationLink,
  UserEvaluationStrong,
  UserEvaluationContainer,
  UserEvaluationBox,
  UserEvaluationRow,
  UserEvaluationRowWithColumn,
  UserEvaluationTitle
} from '../styles';
import UserData from '../UserData';
import { UserEvaluationService } from '../../../services/UserEvaluation';
import { useUserEvaluationContext } from '../../../providers/userEvaluation.provider';
import { useDispatch } from 'react-redux';
import { addToast } from '../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../store/ducks/toast/types';

const RequestApprovalPanel: React.FC<StepPropsRequestApprovalPanel> = ({
  onNext,
  currentScenario
}) => {
  const userEvaluationService = new UserEvaluationService();
  const { userData, setLoading, loading } = useUserEvaluationContext();
  const dispatch = useDispatch();
  const displayMessage = () => {
    dispatch(
      addToast({
        message: 'Por favor, tente novamente mais tarde.',
        type: EToastTypes.DANGER,
        durationInMS: 5000
      })
    );
  };
  const reject = async () => {
    setLoading(true);
    try {
      await userEvaluationService.rejectUser({
        cnpj: userData!.cnpj,
        email: userData!.email,
        prospectUserId: userData!.prospectUserId,
        requester: userData!.requester,
        token: userData!.token
      });
      onNext('fallback');
    } catch (error) {
      displayMessage();
    } finally {
      setLoading(false);
    }
  };

  const approver = async () => {
    setLoading(true);
    try {
      await userEvaluationService.approveUser({
        cnpj: userData!.cnpj,
        email: userData!.email,
        prospectUserId: userData!.prospectUserId,
        requester: userData!.requester,
        token: userData!.token
      });
      onNext('success');
    } catch (error) {
      displayMessage();
    } finally {
      setLoading(false);
    }
  };
  return (
    <UserEvaluationContainer>
      <UserEvaluationBox>
        <UserEvaluationRow>
          <header>
            <UserEvaluationTitle>
              <Title level={1}>
                {currentScenario === 'success'
                  ? 'Solicitação de cadastro'
                  : 'Solicitação expirada ou finalizada'}
              </Title>
            </UserEvaluationTitle>
          </header>

          {currentScenario === 'success' && (
            <p className="item">Confira os dados abaixo:</p>
          )}
        </UserEvaluationRow>

        <UserEvaluationRow>
          {currentScenario === 'success' && (
            <UserData user={userData!} showHeader={true} />
          )}

          {currentScenario === 'fallback' && (
            <section>
              <p className="item">
                Isso ocorre quando a solicitação já foi processada ou
                ultrapassou o limite de sete dias.
              </p>
              <p className="item">
                Se o limite de sete dias tiver sido ultrapassado, peça ao
                cliente que refaça a solicitação. Em caso de dúvida ou suporte,
                entre em contato através dos canais de ajuda:
              </p>
            </section>
          )}
        </UserEvaluationRow>

        {currentScenario === 'success' && (
          <UserEvaluationRow>
            <p className="last">
              Ao aprovar a solicitação, você confirma que reconhece os dados e
              autoriza o cadastro na área do cliente.
            </p>
          </UserEvaluationRow>
        )}

        <UserEvaluationRowWithColumn>
          {currentScenario === 'success' && (
            <div>
              <Button
                onClick={reject}
                variant="danger"
                fullWidth
                name="reject"
                disabled={loading}
              >
                Rejeitar solicitação
              </Button>
            </div>
          )}

          {currentScenario === 'fallback' && (
            <div>
              <p className="item">Telefone</p>
              <p className="item">
                <UserEvaluationStrong>0800 722 3322</UserEvaluationStrong>
              </p>
            </div>
          )}

          {currentScenario === 'success' && (
            <div>
              <Button
                onClick={approver}
                variant="primary"
                fullWidth
                name="approver"
                disabled={loading}
              >
                Aprovar solicitação
              </Button>
            </div>
          )}

          {currentScenario === 'fallback' && (
            <div>
              <p className="item">Email</p>
              <p className="item">
                <UserEvaluationLink>
                  suportegerdaumais@gerdau.com.br
                </UserEvaluationLink>
              </p>
            </div>
          )}
        </UserEvaluationRowWithColumn>
      </UserEvaluationBox>
    </UserEvaluationContainer>
  );
};

export default RequestApprovalPanel;
